import React from 'react';
import { useTheme } from '../context/ThemeContext';
import './ThemeModeIconButton.css';

function SunIcon() {
  return (
    <svg viewBox="0 0 24 24" width="24.2" height="24.2" aria-hidden focusable="false">
      <circle cx="12" cy="12" r="4" fill="currentColor" stroke="none" />
      <g stroke="currentColor" strokeWidth="1.75" strokeLinecap="round">
        <path d="M12 2.5v2.2M12 19.3v2.2M4.2 4.2l1.55 1.55M18.25 18.25l1.55 1.55M2.5 12h2.2M19.3 12h2.2M4.2 19.8l1.55-1.55M18.25 5.75l1.55-1.55" />
      </g>
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg viewBox="0 0 24 24" width="24.2" height="24.2" aria-hidden focusable="false">
      <path
        d="M20.5 14.2a7.8 7.8 0 0 1-9.9-9.9 6.8 6.8 0 1 0 9.9 9.9z"
        fill="currentColor"
        stroke="none"
      />
    </svg>
  );
}

/**
 * Toggles storefront dark theme (ThemeContext + localStorage).
 * Moon = switch to dark; Sun = switch to light.
 */
export default function ThemeModeIconButton({ className = '' }) {
  const { darkMode, toggleDarkMode } = useTheme();

  return (
    <button
      type="button"
      className={['theme-mode-icon-btn', className].filter(Boolean).join(' ')}
      onClick={toggleDarkMode}
      aria-label={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-pressed={darkMode}
      title={darkMode ? 'Light mode' : 'Dark mode'}
    >
      {darkMode ? <SunIcon /> : <MoonIcon />}
    </button>
  );
}
